import { environment } from '../../../../../src/environments/environment';
import { isMobile } from '../../../../../src/app/shared/utils/screen-width';

class TopMenu {
 	  [x: string]: any;
    static $inject = ['AuthService','AccountsService', 'NotificationsService', 'AmplitudeService', '$state'];
    private open = false;
    private isVisible = false;
    private isMobile: boolean;

    constructor(AuthService, AccountsService, NotificationsService, AmplitudeService, $state) {
        this.AuthService = AuthService;
        this.AccountsService = AccountsService;
        this.NotificationsService = NotificationsService;
        this.textLength = 25;
        this.AmplitudeService = AmplitudeService;
        this.$state = $state;
    }

    $onInit() {
        this.isMobile = isMobile();
        let currentState = this.$state.current.name;

        this.isVisible = !currentState.startsWith('accounts');
        if(!this.isVisible) {
          return;
        }

        this.isChannels = document.location.origin === environment.CHANNELS_URL;
        let user = this.AuthService.currentUser();
        this.fullName = `${user.name} ${user.surname}`;
        this.userAvatar = user.avatarUrl;
        this.account = this.AccountsService.currentAccountName();
        this.NotificationsService.get({}, res => {
            this.isTrial = res.trial;
            this.trialExpirationDate = res.trialExpirationDate;
        });
    }

    userDropdownClicked() {
      this.open = !this.open;
      this.AmplitudeService.logEvent('Panel:Menu:Dropdown: Clicked', {
        open: this.open
      });
    }

}
export default {
    template: require('./menu.top.html'),
    controller: TopMenu
};
